export const errorSeverity = {
	error: "Error",
	warning: "Warning",
	information: "Information",
} as const;
